import MotivoCancelamento from './MotivoCancelamento';

export default MotivoCancelamento;